const HOST_ROOT = process.env.REACT_APP_BASEURL

const config = {
  BASE_URL: HOST_ROOT,
}

export default config